export default "__VITE_ASSET__kunUBDID__"